export function goToAnchor(value) {
    $('html, body').animate({
        scrollTop: document.getElementById(value).offsetTop
    }, '50');
}

export function getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

export function isEmailValid(email) {
    const emailRegExp = /^[^\s@]+@([^\s@.,]+\.)+[^\s@.,]{2,}$/;
    return emailRegExp.test(email);
}

window.goToAnchor = goToAnchor;
window.getUrlParameter = getUrlParameter;
window.isEmailValid = isEmailValid;
